module.exports = __webpack_public_path__ + "static/media/lingolink-4.b260d301.jpg";